<template>
    <div class="">
        <aside class="main-sidebar">
            <!-- sidebar: style can be found in sidebar.less -->
            <section class="sidebar">
                <!-- Sidebar Menu -->
                <ul class="sidebar-menu" data-widget="tree">
                    <li class="header">MENU</li>
                    <!-- Optionally, you can add icons to the links -->
                    <router-link
                        tag="li"
                        to="/"
                        class="text-left"
                        exact
                        v-show="!this.$store.state.user.provider_id"
                    >
                        <a>
                            <i class="fa fa-link"></i>
                            <span>Nueva Orden</span>
                        </a>
                    </router-link>
                    <router-link tag="li" to="/orders" class="text-left" exact>
                        <a>
                            <i class="fa fa-table text-left"></i>
                            <span>Listado de ordenes</span>
                        </a>
                    </router-link>
                    <router-link
                        tag="li"
                        to="/dues"
                        class="text-left"
                        exact
                        v-show="this.$store.state.user.provider_id"
                    >
                        <a>
                            <i class="fa fa-table text-left"></i>
                            <span>Ordenes por Cuotas</span>
                        </a>
                    </router-link>
                    <router-link
                        tag="li"
                        to="/pending-orders"
                        class="text-left"
                        exact
                    >
                        <a>
                            <i class="fa fa-table text-left"></i>
                            <span>Pedidos Pendientes</span>
                        </a>
                    </router-link>
                </ul>
                <!-- /.sidebar-menu -->
            </section>
            <!-- /.sidebar -->
        </aside>

        <!-- Content Wrapper. Contains page content -->
        <div class="content-wrapper">
            <!-- Main content -->
            <section class="content container-fluid">
                <slot> </slot>
            </section>
            <!-- /.content -->
        </div>
        <!-- /.content-wrapper -->

        <!-- Main Footer -->
        <footer class="main-footer">
            <!-- To the right -->
            <div class="pull-right hidden-xs">Anything you want</div>
            <!-- Default to the left -->
            <strong>Copyright &copy; 2016 <a href="#">Company</a>.</strong> All
            rights reserved.
        </footer>
    </div>
    <!-- ./wrapper -->
</template>

<script>
export default {
    mounted() {
        // eslint-disable-next-line no-undef
        $("body").layout("fix");
    },
};
</script>
